const handleCheckboxChange = ({ e, setQuery, ...handleProps }) => {
  setQuery(prev => {
    return { ...prev, [handleProps?.name]: e?.target?.checked };
  });
  handleProps?.onChange?.(e?.target?.checked);
};

export default handleCheckboxChange;
